import { getValidSortOptionByPropertyStatus } from './getValidSortOptionByPropertyStatus';
import { SearchPropertyStatus } from '../types';

export const getSortOptionOnPropertyStatusChange = ({
  newPropertyStatus,
  previousPropertyStatus,
  currentSortOption,
  isGeoShapeBasedSearch = false,
}: {
  newPropertyStatus: SearchPropertyStatus;
  previousPropertyStatus: SearchPropertyStatus;
  currentSortOption: string;
  isGeoShapeBasedSearch?: boolean;
}): string => {
  return getValidSortOptionByPropertyStatus({
    propertyStatus: newPropertyStatus ?? previousPropertyStatus,
    sortOption: currentSortOption,
    isGeoShapeBasedSearch,
  });
};
